import React, { useState, useEffect } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import Loader from "../Loader/Loader";
import { post, postupload } from "../utils/helpers/http";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loader, setLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    fetchCustomers();
  }, [pageNo, pageSize, searchKeyword]);

  const fetchCustomers = async () => {
    setLoader(true);
    try {
      let body = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchKeyword: searchKeyword,
      }
      const response = await post('/Customer/CustomerList', body);
      console.log("response** customer list " + searchKeyword, response);
      if (response.data.data) {
        setCustomers(response.data.data.customers);
        setTotalRecords(response.data.data.totalRecords);
        console.log("if customer list")
      } else {
        setCustomers([]);
        setTotalRecords(0);
        console.log("else customer list []");
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (searchQuery.length >= 3) {
      setSearchKeyword(searchQuery);
    } else if (searchQuery.length === 0) {
      setSearchKeyword("");
    }
  }, [searchQuery]);
  const handleSearchChange = (e) => {
    const value = e.target.value.trim();
    setSearchQuery(value);
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setPageNo(1);
  };

  const handleExport = async()=>{
    setLoader(true);
    try {
      let body = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchKeyword: searchKeyword,
      }
      const response = await postupload('/Customer/ExportCustomerToExcel', body, {
        responseType: 'arraybuffer',
      });
      if (response?.data) {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'CustomerList.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } 
        else {  
        console.log("else customer list []");
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  }
  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title">Customer(s)</h1>
                </div>
              </div>
              <div className="page-content">
                <div className="page-content">
                  <div className="table-filters">
                    <div className="left_filters">
                      <div className="filterBox">
                        <label className="form-filter-label">Show</label>
                        <select
                          className="form-filter form-select"
                          onChange={handlePageSizeChange}
                          value={pageSize}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                        </select>
                        <label className="ps-2">entries</label>
                      </div>
                    </div>
                    <div className="right_filters">
                      <button className="btn btn-primary tableBtnCss" onClick={handleExport}>Export</button>
                      <div className="searchBox">
                        <label>Search:</label>
                        <input
                          type="text"
                          className="form-filter"
                          placeholder="Search by Customer name, phone & email"
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-outerbox">
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="20">SNo.</th>
                          <th width="20%">Customer Name</th>
                          <th width="25%">Email</th>
                          <th width="20%">Date of Birth</th>
                          <th width="20%">Phone</th>
                          <th width="20%">Postcode</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customers.length ? customers.map((customer, index) => (
                          <tr key={index}>
                            <td>{(pageNo - 1) * pageSize + index + 1}</td>
                            <td>{`${customer.firstName} ${customer.lastName}`}</td>
                            <td>{customer.email || "-"}</td>
                            <td>{customer.dateOfBirth || "-"}</td>
                            <td>{customer.phoneNumber || "-"}</td>
                            <td>{customer.postCode || "-"}</td>
                          </tr>
                        )) : loader ? "" : (
                          <tr>
                            <td colSpan="6" style={{ textAlign: "center", padding: "20px", fontSize: "large", fontWeight: "bold" }}>
                              No Data Found.
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="table-pagination">
                  <div className="leftpart">
                    <span className="entriesdata">
                      Showing {pageNo} to{" "}
                      {Math.min(pageNo * pageSize, totalRecords)} of {totalRecords} entries{" "}
                    </span>
                  </div>
                  <div className="rightpart">
                    {customers.length > 0 && (
                      <div className="pagination_box">
                        <ul>
                          <li className="prev">
                            <button onClick={() => setPageNo(Math.max(pageNo - 1, 1))}>
                              <i className="fa-solid fa-chevron-left"></i> Previous
                            </button>
                          </li>
                          {[...Array(Math.ceil(totalRecords / pageSize)).keys()].map((page) => (
                            <li key={page} className={page + 1 === pageNo ? "current" : ""}>
                              <button onClick={() => setPageNo(page + 1)}>
                                <span>{page + 1}</span>
                              </button>
                            </li>
                          ))}
                          <li className="next">
                            <button
                              onClick={() => {
                                const maxPage = Math.ceil(totalRecords / pageSize);
                                if (pageNo < maxPage) {
                                  setPageNo(pageNo + 1);
                                }
                              }}
                              disabled={pageNo >= Math.ceil(totalRecords / pageSize)}
                            >
                              Next <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {loader && <Loader />}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Customers;
